import { create } from "zustand";
import { 
  URL_PARAM_PRESET
  // , URL_PARAM_PRESET_LEGACY
} from "../../../var";
import { filterPresetProps, getInitialPreset } from "./utils";
import {CropperPresetInterface} from './preset';
import anime from 'animejs';

export let globalHandler = null;
/** (app) cropper statuses */
export const CROPPER_STATUS_CHANGED = Symbol('changed');
export const CROPPER_STATUS_READY = Symbol('ready');
export const CROPPER_STATUS_NONE = Symbol('none');
export const CROPPER_MAX_HISTORY = 99;

interface CropperStoreDefinition {
  status: symbol;
  setStatus: (status: any) => void;
  setReady: () => void;
  setCropperReady: () => void;
  isCropperReady: () => void;
  setCropperChanged: () => void;
  setCropperNone: () => void;
  preset: CropperPresetInterface|object;
  undo: object;
  redo: object;
  element: HTMLImageElement|null;
  setElement: (element: HTMLImageElement) => void;
  getCropper: () => object|null;
  initPreset: (preset: CropperPresetInterface, zero: boolean) => void;
  updatePreset: (preset: CropperPresetInterface, store: boolean) => void;
  toJSON: any;
  toParams: any;
  isDark: boolean;
  setIsDark: any;
  animate: any;
  animations: object;
}

export const useCropperStore = create((set: any, get: any) : CropperStoreDefinition => ({
  status: CROPPER_STATUS_NONE,
  setStatus: (status: any) => set({ status }),
  setReady: () => set({ status: CROPPER_STATUS_READY }),
  setCropperReady: () => set({ status: CROPPER_STATUS_READY }),
  isCropperReady: () => get().status === CROPPER_STATUS_READY,
  setCropperChanged: () => set({ status: CROPPER_STATUS_CHANGED }),
  setCropperNone: () => set({ status: CROPPER_STATUS_NONE }),
  preset: {},
  undo: [],
  redo: [],
  async initPreset(preset: CropperPresetInterface, zero = false) {
    const initialPreset = getInitialPreset(JSON.parse(JSON.stringify(preset)), zero);
    await set({ preset: initialPreset });
  },
  element: null,
  setElement(element: HTMLImageElement) {
    set({ element });
  },
  getCropper() {
    return get()?.element?.cropper;
  },
  isDark: false,
  setIsDark: (isDark: boolean) => set({ isDark }),
  updatePreset(preset: CropperPresetInterface, store = true) {
    if (store) {
      set((s: CropperStoreDefinition) => ({ preset: { ...s.preset, ...preset }}));
    } else {
      const cropperJS = get()?.element?.cropper;
      if (cropperJS) {
        cropperJS.preset = { ...get().preset, ...preset };
      }
    }
  },
  toJSON() {
    const cropper = get().element.cropper;
    const preset = cropper.preset;
    const {x, y} = cropper.getData();
    const filteredPreset = filterPresetProps({ ...preset, x, y });
    return filteredPreset;
  },
  toParams(encoded: boolean) {
    const jsonPreset = get().toJSON();
    const stringedPreset = JSON.stringify(jsonPreset);
    return {
      [URL_PARAM_PRESET]: encoded ? encodeURIComponent(stringedPreset) : stringedPreset
    };
  },
  animations: ({
    center: () => {
      const position = {
        source: get().element.cropper.getCanvasData(),
        target: get().element.cropper._getCenter(
          get().element.cropper.getCanvasData()
        ),
        left: 0,
        top: 0,
      };
      return {
        targets: position,
        left: [ position.source.left, position.target.left ],
        top: [ position.source.top, position.target.top ],
        update: () => {
          get().element.cropper.setCanvasData(position);
        }
      };
    },
    zoom: (params:any) => {
      console.log(params);
      console.log(get().element.cropper._getCanvasCenterPivot());
      const zoom = {
        value: get().element.cropper._getZoomFactor(),
        ...get().element.cropper._getCanvasCenterPivot()
      }
      const animation = {
        targets: zoom,
        value: params.data.value,
        left: params.data.pivot.left,
        top: params.data.pivot.top,
        update: (anim: object) => {
          get().element.cropper[params.func](zoom.value, { left: zoom.left, top: zoom.top });
        },
      };
      return animation;
    }
  }),
  animate(animName:string, params:object, options:object = {}) {
    return anime({
      easing: 'easeInOutSine',
      duration: 500,
      ...get().animations[animName](params),
      ...options,
    });
  }
}));